const get = state => state.logo

export const logoSelectors = {
    get,
}
